export var PrintoutType;
(function (PrintoutType) {
    PrintoutType["RESERVATION_CONFIRMATION"] = "RESERVATION_CONFIRMATION";
    PrintoutType["RESERVATION_CANCELLATION"] = "RESERVATION_CANCELLATION";
    PrintoutType["FOLIO_CONFIRMATION"] = "FOLIO_CONFIRMATION";
    PrintoutType["AGENDA_HANDOUT"] = "AGENDA_HANDOUT";
})(PrintoutType || (PrintoutType = {}));
export var PrintoutOrientation;
(function (PrintoutOrientation) {
    PrintoutOrientation["PORTRAIT"] = "PORTRAIT";
    PrintoutOrientation["LANDSCAPE"] = "LANDSCAPE";
})(PrintoutOrientation || (PrintoutOrientation = {}));
